
import { useState } from 'react';

export function useMultiStepForm(steps: number) {
  const [currentStep, setCurrentStep] = useState(0);

  function next() {
    setCurrentStep((i) => {
      if (i >= steps - 1) return i;
      return i + 1;
    });
  }

  function back() {
    setCurrentStep((i) => {
      if (i <= 0) return i;
      return i - 1;
    });
  }

  function goTo(step: number) {
    setCurrentStep(step);
  }

  return {
    currentStep,
    isFirstStep: currentStep === 0,
    isLastStep: currentStep === steps - 1,
    goTo,
    next,
    back,
  };
}
